// extracted by mini-css-extract-plugin
export default {"emote":"_11L7C"};